import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { UrlFormatter } from 'shared';

/**
 * Native port of the v1 `BookingEngines` factory (account-v1/src/core/api/
 * bookingEngines.js). WS5 #10 Stage A inc 2x: replaces the
 * `$injector.get('BookingEngines')` grab in ft-touchpoint-integration (the
 * confirmation multi-engine editor: per-engine activate toggle + the engine
 * names/instructions list). Both methods resolve the response BODY (v1
 * `.then(r => r.data)`); `activate` keeps the v1 shape — propertyUUID
 * concatenated into the template, the ENGINE OBJECT as the token model
 * (`:id`/`:isActive` read off it) with no request body.
 */
@Injectable({ providedIn: 'root' })
export class BookingEnginesV1ApiService {
  private readonly http = inject(HttpClient);

  /** v1 `BookingEngines.activate(propertyUUID, engine)`. */
  activate(propertyUUID: string, engine: any): Promise<any> {
    return firstValueFrom(
      this.http.put(
        UrlFormatter.format('/api/' + propertyUUID + '/properties/layers/prestay/confirmation/bookingengines/:id/activate/:isActive', engine),
        null,
      ),
    );
  }

  /** v1 `BookingEngines.get()` — the available booking engines. */
  get(): Promise<any> {
    return firstValueFrom(this.http.get('/api/bookingengines'));
  }
}
